import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import DeleteModal from "../../components/Common/DeleteModal";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { map, isEmpty } from "lodash";

import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

import {
  addEmailListType,
  getEmailListType,
  updateEmailListType,
  deleteEmailListType,
} from "../../store/actions";

const EmailListType = props => {
  const {
    emaillisttypes,
    loading,
    addEmailListType,
    onGetEmailListType,
    onDeleteProType,
    onUpdateEmailListType,
    t,
  } = props;

  const [emailListType, setEmailListType] = useState({});
  const [isRight, setIsRight] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    onGetEmailListType(localStorage.getItem("userId"));
  }, [onGetEmailListType]);

  useEffect(() => {
    if (!isEmpty(emaillisttypes)) {
      setIsEdit(false);
    }
  }, [emaillisttypes]);

  const toggleCanvas = () => setIsRight(prev => !prev);

  const openEditCanvas = item => {
    setEmailListType({
      id: item.id,
      emailListTypeId: item.emailListTypeId,
      emailListTypeTitle: item.emailListTypeTitle,
      agentId: item.agentId,
      isActive: item.isActive,
    });
    setIsEdit(true);
    toggleCanvas();
  };

  const handleAdd = values => {
    addEmailListType(values);
  };

  const onClickDelete = item => {
    setEmailListType(item);
    setDeleteModal(true);
  };

  const handleDelete = () => {
    if (emailListType?.id) {
      onDeleteProType(emailListType);
      setDeleteModal(false);
    }
  };

  return (
    <React.Fragment>
      {loading && <div className="loading">Loading…</div>}

      <ToastContainer autoClose={2000} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
       
        <Container fluid>
          <Row className="mb20">
            <Col xl="12">
              <Breadcrumbs title={t("General Settings")} breadcrumbItem={t("Email List Type")} />
            </Col>
          </Row>

          <Row>
            
            <Col xl="12">
              {/* ===== ADD FORM ===== */}
              <Formik
                enableReinitialize
                initialValues={{
                  emailListTypeTitle: "",
                  agentId: parseInt(localStorage.getItem("userId")),
                }}
                validationSchema={Yup.object({
                  emailListTypeTitle: Yup.string().required("This is required"),
                })}
                onSubmit={handleAdd}
              >
                {({ errors, touched, handleChange }) => (
                  <Form>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col sm="3">
                            <FormGroup>
                              <Label>{t("Title")}</Label>
                              <SafeField
                                name="emailListTypeTitle"
                                onChange={handleChange}
                                className={`form-control ${
                                  errors.emailListTypeTitle && touched.emailListTypeTitle
                                    ? "is-invalid"
                                    : ""
                                }`}
                              />
                              <ErrorMessage
                                name="emailListTypeTitle"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>

                          <Col sm="2" className="">
                            <Button type="submit" color="primary" className="mt-4">
                              Add
                            </Button>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Form>
                )}
              </Formik>

              {/* ===== LIST ===== */}
              <Card>
                <CardBody>
                  <h5>History</h5>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Title</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {map(emaillisttypes, (item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{item.emailListTypeTitle}</td>
                            <td>
                              <ActionEdit onClick={() => openEditCanvas(item)} />
                              <ActionDelete onClick={() => onClickDelete(item)} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* ===== UPDATE OFFCANVAS ===== */}
          <Offcanvas isOpen={isRight} direction="end" toggle={toggleCanvas}>
            <OffcanvasHeader toggle={toggleCanvas}>Update</OffcanvasHeader>
            <OffcanvasBody>
              <Formik
                enableReinitialize
                initialValues={emailListType}
                validationSchema={Yup.object({
                  emailListTypeTitle: Yup.string().required("This is required"),
                })}
                onSubmit={values => {
                  if (isEdit) {
                    const updateData = {
                      id: values.id,
                      emailListTypeId: values.emailListTypeId,
                      emailListTypeTitle: values.emailListTypeTitle,
                      agentId: values.agentId,
                    };
                    onUpdateEmailListType(updateData);
                  }
                  toggleCanvas();
                }}
              >
                {({ errors, touched, handleChange }) => (
                  <Form>
                    <FormGroup>
                      <Label>{t("Title")}</Label>
                      <SafeField
                        name="emailListTypeTitle"
                        onChange={handleChange}
                        className={`form-control ${
                          errors.emailListTypeTitle && touched.emailListTypeTitle
                            ? "is-invalid"
                            : ""
                        }`}
                      />
                      <ErrorMessage
                        name="emailListTypeTitle"
                        component="div"
                        className="invalid-feedback"
                      />
                    </FormGroup>

                    <Button type="submit" color="primary">
                      Update
                    </Button>
                  </Form>
                )}
              </Formik>
            </OffcanvasBody>
          </Offcanvas>
        </Container>
      </div>
    </React.Fragment>
  );
};

EmailListType.propTypes = {
  t: PropTypes.any,
  loading: PropTypes.bool,
  emaillisttypes: PropTypes.array,
  addEmailListType: PropTypes.func,
  onGetEmailListType: PropTypes.func,
  onDeleteProType: PropTypes.func,
  onUpdateEmailListType: PropTypes.func,
};

const mapStateToProps = ({ ObjectReducer }) => ({
  emaillisttypes: ObjectReducer.emaillisttypes,
  loading: ObjectReducer.loading,
});

const mapDispatchToProps = dispatch => ({
  addEmailListType: data => dispatch(addEmailListType(data)),
  onGetEmailListType: agentId => dispatch(getEmailListType(agentId)),
  onDeleteProType: data => dispatch(deleteEmailListType(data)),
  onUpdateEmailListType: data => dispatch(updateEmailListType(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EmailListType));
